export default __webpack_public_path__ + "static/media/chat-itc.80594e72.svg";